module.exports = __webpack_public_path__ + "static/media/ESS_regulator.b353f704.jpg";